import { gql } from '@apollo/client';

// shared by ImpactDirectionByGgVar, StackRankDriversTable, and AllOFPsCorrelatesOfQualityDownload
export default gql`
query ReportPositiveNegativeDriversQuery($reportID: UUID!) {
    allRpFlavorStructures(
      condition: { reportId: $reportID} 
    ) {
      nodes {
        product: productByProductId {
          id
          name
        }
        label
        nodeColor
      }
    }
  }
`;